import React from "react";
import { Classes, Dialog, DialogProps } from "@blueprintjs/core";
import useDarkMode from "./use-dark-mode";

const ThemedDialog: React.FC<DialogProps> = ({ ...dialogProps }) => {
  const [darkMode] = useDarkMode();
  const className = [darkMode ? Classes.DARK : "", dialogProps.className ?? ""]
    .join(" ")
    .trim();
  return <Dialog {...dialogProps} className={className} />;
};

export default ThemedDialog;
